import HeaderView from './HeaderView';
import HeaderUserView from './HeaderUserView';

export {
    HeaderView,
    HeaderUserView
};



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/layout/index.js